import React from "react";
import "./CloseButton.css";

interface Props {
  onClick?: () => void;
  ariaLabel?: string;
  size?: number;
  className?: string;
  disabled?: boolean;
}

const CloseButton: React.FC<Props> = ({
  onClick,
  ariaLabel = "Close",
  size = 20,
  className = "",
  disabled = false,
}) => (
  <button
    className={`close-btn ${className}`.trim()}
    onClick={onClick}
    aria-label={ariaLabel}
    disabled={disabled}
  >
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M18 6L6 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M6 6L18 18"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  </button>
);

export default CloseButton;
